<template>
  <f7-sheet
    class="content-action-sheet padding-vertical-half"
    :opened="opened"
    close-by-outside-click
    @sheet:close="emitClose"
  >
    <div class="content-action-sheet__title text-align-center">
      {{ $t('common.whatDoYouWantToDoWith') }} <b>{{ crop.name }}</b>
    </div>
    <div class="content-action-sheet__actions">
      <div class="text-align-center content-action-sheet__actions--delete">
        <img
          :src="deleteIcon"
          @click="deleteClicked"
        >
        <span>{{ $t('common.delete') }}</span>
      </div>
      <div class="text-align-center content-action-sheet__actions--edit">
        <img
          :src="editIcon"
          @click="editClicked"
        >
        <span>{{ $t('common.edit') }}</span>
      </div>
    </div>
  </f7-sheet>
</template>

<script>
import deleteIcon from '@/static/img/ic_button_delete.svg';
import editIcon from '@/static/img/ic_button_edit.svg';
import CropService from '@/js/services/contracts/Crops';
import { ConfirmDialogGH } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';

export default {
  name: 'CropActionSheet',
  props: {
    opened: { type: Boolean, default: false },
    crop: { type: Object, default: undefined },
  },

  emits: [
    'delete-crop',
    'edit-crop',
    'sheet:close',
  ],

  computed: {
    deleteIcon: () => deleteIcon,
    editIcon: () => editIcon,
  },
  methods: {
    async deleteClicked() {
      this.emitClose();
      this.$emit('delete-crop', this.crop);

      const res = await ConfirmDialogGH(this.$t('EliminarCultivo'), this.$t('common.delete'));

      if (res) {
        CropService.deleteById(this.crop.id);
      }
    },
    editClicked() {
      this.emitClose();
      this.$emit('edit-crop', this.crop);
      f7.views.main.router.navigate('/new-crop/', {
        props: {
          cropId: Number.parseInt(this.crop.id, 10),
          fieldId: Number.parseInt(this.crop.field, 10),
        },
      });
    },
    emitClose() {
      this.$emit('sheet:close');
    },
  },
};
</script>

<style scoped lang="scss">
.content-action-sheet {
  height: 20vh;
}

.col {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

span {
  display: block;
  color: var(--ha-blue);
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
}
</style>
